import React from "react";
import { CustomComponentCustomFormField, CustomFormSegmentReportData } from "../../../../../amorg-common";
import { Card } from "../../../../../designSystem/Card";
import { H2 } from "../../../../../designSystem/typography/Heading";
import { CustomFormReportBar } from "../DiscreteValueReportField";

type TimePointsReportFieldProps = {
    field:CustomComponentCustomFormField,
    segmentReports:CustomFormSegmentReportData[]
}
export function TimePointsReportField(props:TimePointsReportFieldProps):JSX.Element
{
    const selections:{value:string, count:number}[] = [];
    for(const segmentReport of props.segmentReports)
    {
        const fieldSelections = segmentReport.dataSelections.find(s => s.fieldId === props.field.fieldId);
        if(fieldSelections)
        {
            for(const fs of fieldSelections.selection)
            {
                // catches type===Suggester
                const value = fs.value || '[ingen værdi]';

                let valueCounter = selections.find(s => s.value === value);
                if(!valueCounter)
                {
                    valueCounter = { value, count:0 };
                    selections.push(valueCounter);
                }
                valueCounter.count ++;
            }
        }
    }

    const countSum = selections.reduce((acc, s) => acc + s.count, 0);

    return (
        <Card variant="outlined">
        <H2>{props.field.label}</H2>
        {selections.map((s) => {

            const pct = s.count / countSum * 100;
            const text = `${getValueValues(s.value).join(' | ')} (${s.count})`;

            return (
                <CustomFormReportBar key={props.field.fieldId + "_" + s.value}
                    pct={pct}
                    text={text}
                />
            );
        })}
        </Card>
    );
}

function getValueValues(value: string): string[] {
    
    let values = [value];
    
    if(value === '1')
        values = ['< 10 gange','< 5 min','< 300m'];
    
    else if(value === '2')
        values = ['10 til < 40 gange','5 til < 15 min','300m til < 1km'];

    else if(value === '4')
        values = ['40 til < 200 gange','15 min til < 1t','1km til < 4km'];
    
    else if(value === '6')
        values = ['200 til < 500 gange','1t til < 2t','4km til < 8km'];

    else if(value === '8')
        values = ['500 til < 1000 gange','2t til < 4t','8km til < 16km'];

    else if(value === '10')
        values = ['flere end 1000 gange','mere end 4t','mere end 20km'];

    return values;
}